import { useState, useEffect } from "react";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import SelectCustom from "../../../../component/elements/selectCustom/index";
import TextFieldCustom from "../../../../component/elements/textfieldCustom/index";
import { validateForm } from "../../../../utils/formValidation/validation";
import { serviceOffered } from "../../../../utils/formValidation/validationRules";
import axiosInstance from "../../../../configuration/request";

const serviceTypeOptions = [{ value: "WASH_N_FOLD", label: "Wash & Fold" }];
const serviceTypeOptions2 = [
  { value: "DRYCLEANING", label: "Dry Cleaning" },
  // { value: "IRONING", label: "Ironing" },
  { value: "TAILORING", label: "Tailoring" },
];

const unitOptions = [
  { value: "piece", label: "Unit" },
  { value: "pound", label: "Pound" },
];

function ServiceOfferedForm({ onClose, onSubmit, dialogDetails }) {
  const [formData, setFormData] = useState({
    serviceType: "",
    category: "",
    unit: "",
    tailoringType: "",
    clothType: "",
    description: "",
    price: "",
    lbs: "1",
  });
  const [formErrors, setFormErrors] = useState({});
  const [serviceTypeDropdown, setServiceTypeDropdown] = useState([]);
  const [tailoringTypeDropdown, setTailoringTypeDropdown] = useState([]);
  const [clothDropdown, setClothDropdown] = useState([]);
  const [categoryDropdown, setCategoryDropdown] = useState([]);
  // const lbsOptions = Array.from({ length: 100 }, (_, i) => ({
  // label: `${i + 1} lbs`,
  // value: i + 1,
  // }));

  useEffect(() => {
    if (dialogDetails) {
      setFormData({
        unit: dialogDetails?.unit || "",
        serviceType: dialogDetails?.serviceType || "",
      });
      initializeDropdowns(dialogDetails);
    }
  }, [dialogDetails]);

const initializeDropdowns = async (details) => {
  if (details.unit) {
    setServiceTypeDropdown(
      details.unit === "pound" ? serviceTypeOptions : serviceTypeOptions2
    );
  }

  let category = details?.category || "";
  let clothType = details?.clothType || "";
  let tailoringType = details?.tailoringType || "";

  if (details.serviceType === "WASH_N_FOLD") {
    let data = await fetchDropdownData("wash_fold");
    if (!data.some((opt) => opt.value === category)) {
      category = "";  // clear if not found
    }
    setCategoryDropdown(data);
  } else {
    let catData = await fetchDropdownData("cloth_category");
    if (!catData.some((opt) => opt.value === category)) {
      category = "";  // clear if not found
    }
    setCategoryDropdown(catData);

    let clothData = await fetchDropdownData("cloth_name");
    if (!clothData.some((opt) => opt.value === clothType)) {
      clothType = "";  // clear if not found
    }
    setClothDropdown(clothData);

    if (details.serviceType === "TAILORING") {
      let tailoringData = await fetchDropdownData("tailoring_type");
      if (!tailoringData.some((opt) => opt.value === tailoringType)) {
        tailoringType = "";  // clear if not found
      }
      setTailoringTypeDropdown(tailoringData);
    }
  }

  setFormData((prev) => ({
    ...prev,
    category,
    price: details?.price || "",
    tailoringType,
    clothType,
    description: details?.description || "",
    lbs: "1",
  }));
};


  const fetchDropdownData = async (label) => {
    try {
      const res = await axiosInstance.get(`/customer/core/dropdown/${label}`);
      return (
        res?.data?.value?.map((item) => ({ value: item, label: item })) || []
      );
    } catch (error) {
      console.error(`Failed to fetch data for ${label}:`, error);
      return [];
    }
  };

  const handleChange = async (e, field) => {
    const value = e?.target?.value;
    let previous = formData.serviceType;
    if (field === "unit") {
      handleUnitChange();
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: "" }));

    if (field === "unit") {
      setFormData((prev) => ({ ...prev, [field]: value }));
      setServiceTypeDropdown(
        value === "pound" ? serviceTypeOptions : serviceTypeOptions2
      );
    }
    if (field === "serviceType") {
      if (value === "WASH_N_FOLD") {
        const data = await fetchDropdownData("wash_fold");
        setCategoryDropdown(data);
      } else {
        if (previous === "WASH_N_FOLD") {
          const data = await fetchDropdownData("cloth_category");
          setCategoryDropdown(data);
        } else if (categoryDropdown.length === 0) {
          const data = await fetchDropdownData("cloth_category");
          setCategoryDropdown(data);
        }
        if (clothDropdown.length === 0) {
          const data3 = await fetchDropdownData("cloth_name");
          setClothDropdown(data3);
        }
        if (value === "TAILORING") {
          if (tailoringTypeDropdown.length === 0) {
            const data2 = await fetchDropdownData("tailoring_type");
            setTailoringTypeDropdown(data2);
          }
        }
      }
    }
  };

  const handleUnitChange = () => {
    setFormData({
      serviceType: "",
      category: "",
      tailoringType: "",
      clothType: "",
      description: "",
      price: "",
      lbs: "1",
    });
  };

  const handleSubmit = () => {
    const dynamicRules = { ...serviceOffered };
    if (formData.serviceType === "TAILORING")
      dynamicRules.tailoringType.required = true;
    else dynamicRules.tailoringType.required = false;

    if (formData.unit === "piece") dynamicRules.clothType.required = true;
    else dynamicRules.clothType.required = false;

    // if (formData.unit === "pound") dynamicRules.lbs.required = true;
    // else dynamicRules.lbs.required = false;
    const errors = validateForm(formData, dynamicRules);

    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      if (dialogDetails) {
        const fullFormData = {
          ...formData,
          itemId: dialogDetails.unit_pound_id,
        };
        onSubmit(fullFormData);
      } else {
        onSubmit(formData);
      }
    }
  };

  return (
    <div className="py-4 px-6">
      <div className="flex justify-between mb-6">
        <div className="text-lg font-[500]">Add Services</div>
        <button
          className="text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>
      <div>
        <Box
          sx={{
            display: "grid",
            gap: 2,
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              lg: "1fr 1fr 1fr 1fr",
            },
          }}
        >
          <SelectCustom
            label="Quantity Type*"
            options={unitOptions}
            value={formData.unit || ""}
            onChange={(e) => handleChange(e, "unit")}
            error={!!formErrors.unit}
            helperText={formErrors.unit || " "}
          />
          <SelectCustom
            label="Service Type*"
            options={serviceTypeDropdown}
            value={formData.serviceType}
            onChange={(e) => handleChange(e, "serviceType")}
            error={!!formErrors.serviceType}
            helperText={formErrors.serviceType || " "}
          />
          <SelectCustom
            label="Category*"
            options={categoryDropdown}
            value={formData.category}
            onChange={(e) => handleChange(e, "category")}
            error={!!formErrors.category}
            helperText={formErrors.category || " "}
          />
          {formData?.unit === "piece" && (
            <SelectCustom
              label="Cloth*"
              options={clothDropdown}
              value={formData.clothType}
              onChange={(e) => handleChange(e, "clothType")}
              error={!!formErrors.clothType}
              helperText={formErrors.clothType || " "}
            />
          )}

          {/* {formData?.unit === "pound" && (
              <SelectCustom
            label="lbs*"
            options={lbsOptions}
            value={formData.lbs}
            onChange={(e) => handleChange(e, "lbs")}
            error={!!formErrors.lbs}
            helperText={formErrors.lbs || " "}
          />
          )} */}

          {formData?.serviceType === "TAILORING" && (
            <SelectCustom
              label="Tailoring Type*"
              options={tailoringTypeDropdown}
              value={formData.tailoringType}
              onChange={(e) => handleChange(e, "tailoringType")}
              error={!!formErrors.tailoringType}
              helperText={formErrors.tailoringType || " "}
            />
          )}

         <div>
           <TextFieldCustom
            label="Price*"
            fullWidth
            value={formData.price}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                handleChange(e, "price");
              }
            }}
            error={!!formErrors.price}
            helperText={formErrors.price || " "}
          />
          {dialogDetails && ( 
            <div className="text-[10px] -mt-4 text-slate-500">
    Max 20% increase allowed.
  </div>
          )}
         
         </div>
        </Box>
        <div className="mt-6">
          <TextFieldCustom
            label="Description (optional)"
            heightClass={"custom-textarea-height"}
            fullWidth
            multiline
            value={formData.description}
            onChange={(e) => handleChange(e, "description")}
            error={!!formErrors.description}
            helperText={formErrors.description || " "}
          />
        </div>
      </div>
      <div className="flex flex-col xs:flex-row justify-center items-center mt-8 mb-4 gap-3">
        <CustomButton
          onClick={onClose}
          customeClass="primary-custom-button w-full xs:w-[150px] h-[40px]"
        >
          Cancel
        </CustomButton>
        <CustomButton
          onClick={handleSubmit}
          customeClass="gradient-button w-full xs:w-[150px] h-[40px]"
        >
          Submit
        </CustomButton>
      </div>
    </div>
  );
}

export default ServiceOfferedForm;
